import React from 'react';

import { useIntl } from 'react-intl';

import { A11yWrapper } from 'components/a11y-wrapper';

import {
  StyledDonationCard,
  StyledDonationSubTitle,
  StyledDonationTitle,
  StyledToggleButtonGroup,
} from './styled';
import { IDonationAtCheckoutProps } from './types';

const DonationAtCheckout: React.FC<IDonationAtCheckoutProps> = ({
  header,
  subtitle,
  donationOptions,
  selectedDonationId,
  onChangeValue,
}) => {
  const { formatMessage } = useIntl();
  const selectDonationAmountText = formatMessage({ id: 'selectDonationAmount' });

  const handleChange = (value: string | null) => {
    if (!onChangeValue || !value) {
      return;
    }
    onChangeValue(value);
  };

  return (
    <StyledDonationCard>
      <A11yWrapper>
        <StyledDonationTitle>{header}</StyledDonationTitle>
      </A11yWrapper>
      <A11yWrapper>
        <StyledDonationSubTitle>{subtitle}</StyledDonationSubTitle>
      </A11yWrapper>
      <StyledToggleButtonGroup
        options={donationOptions}
        onChangeValue={handleChange}
        value={selectedDonationId}
        accessibilityHint={selectDonationAmountText}
        accessibilityLabel={selectDonationAmountText}
      />
    </StyledDonationCard>
  );
};

export default DonationAtCheckout;
